import React from "react";
import img from "../../assets/images/Screenshot 2024-12-13 214614.png";
import img2 from "../../assets/images/p2.png";
import img3 from "../../assets/images/p3.png";
import img4 from "../../assets/images/p4.png";
import img5 from "../../assets/images/p5.png";
import img6 from "../../assets/images/p6.png";

const AllProjects = () => {
  return (
    <section className="w-full flex flex-col items-center justify-center pt-[100px] bg-[#111] text-white">
      <p
        data-aos="fade-down"
        className="text-[#76cfff] text-[18px] font-bold tracking-[4px] uppercase mb-10 text-center md:text-[16px] md:mb-8 sm:text-[14px] sm:mb-5"
      >
        Know more about us!
      </p>

      <h1
        data-aos="fade-down"
        className="text-[100px] leading-[110px] text-center text-white uppercase font-poppins font-semibold mb-[30px] md:text-[60px] md:leading-[70px] sm:text-[40px] sm:leading-[50px]"
      >
        Gallery
      </h1>

      <div className="flex flex-wrap justify-center gap-[40px] md:gap-[30px] sm:gap-[20px] overflow-hidden">
        {projectsData.map((project, index) => (
          <div
            key={project.id}
            className="relative w-[calc(100%-20px)] max-w-[400px] mb-[30px] rounded-[14px] overflow-hidden cursor-pointer z-[1111] transition-transform duration-300 hover:scale-[1.03]"
            data-aos="zoom-in"
            data-aos-delay={`${index * 100}`}
          >
            {/* Blurred Blob */}
            <div
              className="absolute z-[1] top-1/2 left-1/2 rounded-full bg-gradient-to-br from-[#76cfff] to-black opacity-100 blur-[12px] animate-[blob-bounce_10s_infinite_ease]"
              style={{
                width: window.innerWidth < 480 ? "150px" : window.innerWidth < 768 ? "200px" : "250px",
                height: window.innerWidth < 480 ? "150px" : window.innerWidth < 768 ? "200px" : "250px",
                transform: "translate(-100%, -100%)",
              }}
            ></div>

            {/* Image Card */}
            <div
              className="absolute top-[5px] left-[5px] w-[calc(100%-10px)] h-[calc(100%-10px)] z-[2] bg-white/95 backdrop-blur-[24px] rounded-[10px] overflow-hidden
              md:w-[290px] md:h-[290px] sm:w-[240px] sm:h-[240px]"
            >
              <img
                src={project.img}
                alt={project.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Optional Content (currently commented) */}
            {/* <div className="z-[3] p-5 text-center opacity-0 invisible transition-all duration-300 group-hover:opacity-100 group-hover:visible">
              <h3 className="text-[40px] leading-[50px] text-white font-poppins font-semibold md:text-[30px] md:leading-[40px] sm:text-[24px] sm:leading-[30px]">
                {project.title}
              </h3>
              <p className="text-white font-light text-[16px] md:text-[14px] sm:text-[12px]">
                {project.description}
              </p>
            </div> */}
          </div>
        ))}
      </div>
    </section>
  );
};

const projectsData = [
  { id: 1, img: img, title: "Project Title 1", description: "..." },
  { id: 2, img: img2, title: "Project Title 2", description: "..." },
  { id: 3, img: img3, title: "Project Title 3", description: "..." },
  { id: 4, img: img4, title: "Project Title 4", description: "..." },
  { id: 5, img: img5, title: "Project Title 5", description: "..." },
  { id: 6, img: img6, title: "Project Title 6", description: "..." },
];

export default AllProjects;
